import React from "react";
import { BiSolidDashboard, BiUser, BiUserPin, BiLogOut } from "react-icons/bi";
import { FiMenu, FiPhoneCall, FiClock } from "react-icons/fi";
import { GrHistory } from "react-icons/gr";
import { MdPeopleAlt } from "react-icons/md";
import { MdDoNotDisturb,MdOutlinePendingActions, MdCallHistory } from "react-icons/md";
import { useEffect } from 'react';


const Sidebar = ({ isSidebarOpen, setIsSidebarOpen, setView, handleLogout, user }) => {

  // Add effect to handle screen size changes
  useEffect(() => {
    const handleResize = () => {
      // Check if window width is less than 1300px
      if (window.innerWidth < 1300) {
        setIsSidebarOpen(false); // Close sidebar
      } else {
        setIsSidebarOpen(true); // Open sidebar (optional, remove if you want to maintain current state)
      }
    };
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Call handler right away to set initial state
    handleResize();
    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);

  },
  [setIsSidebarOpen]); // Dependency array includes setIsSidebarOpen

  return (
    <aside
      className={`${
        isSidebarOpen ? "w-60" : "w-16"
      } bg-gray-50 text-black transition-all duration-300 ease-in-out flex flex-col shadow-lg border`}
      aria-label="Sidebar"
    >
      <div className="p-4">
        <div className="flex items-center justify-between">
          {isSidebarOpen && <h2 style={{ color:"black" ,fontSize: "35px" }} className="login-title">
        <span style={{ color: "#007bff", fontSize: "37px" }}>R</span>yngmo!
      </h2>}
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="rounded transition-colors"
            aria-label="Toggle sidebar"
          >
            <FiMenu size={24} />
          </button>
        </div>
      </div>
      <nav className="mt-4 flex-grow">
        <div className="px-4 py-2 text-gray-400 uppercase text-sm">
          {isSidebarOpen && "Call Room"}
        </div>
        <ul className="space-y-2 px-2">

        <li>
            <button
              onClick={() => setView("Dashboard")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-300 transition-colors"
              aria-label="CRM"
            >
              <BiSolidDashboard size={24} className="text-blue-600" />
              {isSidebarOpen && <span className="ml-3">Dashboard</span>}
            </button>
          </li>
   {/* <li>
            <button
              onClick={() => setView("Agents-CCE")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="Agents-CCE"
            >
    <MdOutlinePendingActions size={24} />
              {isSidebarOpen && <span className="ml-3">Agents-CCE</span>}
            </button>
          </li> */}

          {/* <li>
            <button
              onClick={() => setView("CRM")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="CRM"
            >
              <BiUserPin size={24} />
              {isSidebarOpen && <span className="ml-3">CRM</span>}
            </button>
          </li> */}





          <li>
            <button
              onClick={() => setView("TotalCustomers")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-300 transition-colors"
              aria-label="TotalCustomers"
            >
              {/* <BiSolidDashboard size={24} className="text-blue-600" /> */}
              <MdPeopleAlt size={24} className="text-blue-600" />
              {isSidebarOpen && <span className="ml-3">Clients</span>}
            </button>
          </li>










       
          <li>
            <button
              onClick={() => setView("CallHistory")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-300 transition-colors"
              aria-label="CallHistory"
            >
              {/* <BiSolidDashboard size={24} className="text-blue-600" /> */}
              <GrHistory size={24} className="text-blue-600" />
              {isSidebarOpen && <span className="ml-3">History</span>}
            </button>
          </li>

 
          {/* <li>
  <button
    // onClick={() => setView("DoNotDisturb")}
    className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
    aria-label="DoNotDisturb"
  >
     <MdOutlinePendingActions size={24} />
   
    {isSidebarOpen && <span className="ml-3">Call Queus</span>}
  </button>
</li> */}

{/* <li>
  <button
    // onClick={() => setView("WaitingList")}
    className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
    aria-label="WaitingList"
  >
    <MdOutlinePendingActions size={24} />
    {isSidebarOpen && <span className="ml-3">Call Notes</span>}
  </button>
</li>  */}


{/* <li>
  <button
    // onClick={() => setView("WaitingList")}
    className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
    aria-label="WaitingList"
  >
    <MdOutlinePendingActions size={24} />
    {isSidebarOpen && <span className="ml-3">Reports</span>}
  </button>
</li>  */}

{/* <li>
  <button
    onClick={() => setView("DoNotDisturb")}
    className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
    aria-label="DoNotDisturb"
  >
     <MdDoNotDisturb size={24} />
    {isSidebarOpen && <span className="ml-3">DNC List</span>}
  </button>
</li>  */}




        </ul>
      </nav>

      <div className="mt-auto px-3">
        <button
          onClick={handleLogout}
          className="flex items-center w-full p-2 rounded transition-colors"
          aria-label="Logout"
        >
          <BiLogOut size={24} />
          {isSidebarOpen && <span className="ml-3">Logout</span>}
        </button>

        <div className="flex items-center w-full p-2 rounded transition-colors mt-4">
          <BiUser size={24} />
          {isSidebarOpen && <span className="ml-3">{user}</span>}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
